module.exports = __webpack_public_path__ + "static/media/handle.4cfbfcb2.svg";